import *  as  constants from "../Config/Constant";
import { handleResponse } from "../Services/HandleResponse";
import { getData } from "../Services/Helper";
import * as types from "../Utilities/Type";
import { getBackEndConstant } from "../Config/Constant";

export function getLoginUser() {
  return (dispatch) => {
      const requestOptions = getData();
      let url = getBackEndConstant().backend_url + "get_login_user";
      return fetch(url, requestOptions)
          .then((response) => handleResponse(response, dispatch))
          .then(response => {
              dispatch({
                  type: types.GET_LOGIN_USER,
                  payload: (response.result) ? response.result : {},
              });
          });
  }
}

export function getLoginUserPermission() {
    return (dispatch) => {
        const requestOptions = getData();
        let url = getBackEndConstant().backend_url + "get_user_role_permissions";
        return fetch(url, requestOptions)
            .then((response) => handleResponse(response, dispatch))
            .then(response => {
                dispatch({
                    type: types.GET_LOGIN_USER_PERMISSION,
                    payload: (response.result) ? response.result : {},
                });
                return response;
            });
    }
   
  }




